import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import "./scss/style.scss";

import apiController from "./controllers/Api";

import { default as _i18n } from "i18next";
import HttpApi from "i18next-http-backend";

import config from "./config/config.json";
import { initialStoreState } from "./store";
import Spinner from "./components/core/UI/Spinner";

export const GLOBAL_NON_REACTIVE_CACHE = {
  // ? CACHES:
  // * File: Lumit-calendar => Production.js
  // machineTaskTypes: /machine-task-types => filter: {}
  // genericTypeOptions: /generic-type-options => filter: {where: {}},
  // genericTypes:  /generic-types => filter: {where: {}, order: ["order ASC", "name ASC"]},
  // prodSectors: /sectors => dynamic filter
  // prodShiftTemplates: /shift-templates => dynamic filter
  // productionCalendar: multiple responses
};

const baseUrl = window.PRODTRACK_CONFIGS.API.HOST || "http://localhost:3000";

// Containers
const TheLayout = React.lazy(() => import("./containers/TheLayout"));

// Pages
const Login = React.lazy(() => import("./views/pages/login/Login"));
const SetPassword = React.lazy(() => import("./views/pages/login/SetPassword"));
const Reset = React.lazy(() => import("./views/pages/login/Reset"));
const Recover = React.lazy(() => import("./views/pages/login/Recover"));
const Logout = React.lazy(() => import("./views/pages/logout/Logout"));
const Register = React.lazy(() => import("./views/pages/register/Register"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));

class App extends Component {
  state = {
    loading: true,
    menus: [],
    links: [],
    schemas: [],
    widgets: [],
    accessToken: false,
    profile: false,
    i18n: {
      t: function (v) {
        return v;
      },
    },
    breakpoints: {
      /*
      lg: 1200,
      md: 996,
      sm: 768,
      xs: 480
      */
      /*
      xs: <540
      sm: >= 540px,
      md: >= 720px,
      lg: >= 960px,
      xl: >=1140px,
      xxl: >= 1400px
      */
      xs: [0, 539],
      sm: [540, 719],
      md: [720, 959],
      lg: [960, 1139],
      xl: [1140, 1399],
      xxl: [1400, Infinity],
    },
    currentBreakpoint: "lg",
    version: this.props.version,
  };

  componentDidUpdate = async () => {
    // !Do not fetch links here as it causes special bugs here - await doesn't work on first time fot getLinks()
  };

  componentDidMount = async () => {
    this.onWindowResize();
    document.title = process.env.REACT_APP_TITLE || "Prod Inspekt";
    document
      .getElementById("favicon")
      .setAttribute("href", process.env.REACT_APP_FAVICON || "/prod-inspekt-fav.svg");

    apiController.setStateCallback(this.setState);
    apiController.setProps(this.props);
    apiController.createInstance();

    await this.loadInternationalization();
    await this.verifyVersion();

    const dispatch = this.props.dispatch;

    dispatch({
      type: "set",
      viewError: undefined,
    });

    console.log(this.props.schemas, "schemas-appjs");
  };

  componentWillUnmount() {
    const dispatch = this.props.dispatch;

    dispatch({
      type: "set",
      viewError: undefined,
    });
  }

  onWindowResize() {
    const dispatch = this.props.dispatch;

    let windowWidth = window.innerWidth;
    let currentBreakpoint = "lg";
    let breakpoints = this.state.breakpoints;

    for (let key in breakpoints) {
      //console.log(key, windowWidth, breakpoints[key][0], breakpoints[key][1]);

      if (windowWidth >= breakpoints[key][0] && windowWidth <= breakpoints[key][1]) {
        currentBreakpoint = key;
      } //if
    } //for

    dispatch({
      type: "set",
      currentBreakpoint: currentBreakpoint,
    });
  }

  async loadInternationalization() {
    let profile = this.props.profile;

    // Load i18n lib
    _i18n.use(HttpApi).init({
      debug: false,
      initImmediate: true,
      lng: "pt",
      fallbackLng: "en",
      preload: ["pt", "en"],
      ns: "prodtrack",
      defaultNS: "prodtrack",
      backend: {
        loadPath: baseUrl + "/locales/{{lng}}/{{ns}}",
        queryStringParams: {
          entity: profile ? profile.entity.id : undefined,
        },
      },
      interpolation: {
        escapeValue: false,
      },
    });

    _i18n.changeLanguage("pt");

    //i18n = _i18n;
    this.setState({
      i18n: _i18n,
    });
  }

  /**
   * Checks the current and previous version and logout the user in case of version mis-match
   */
  async verifyVersion() {
    const dispatch = this.props.dispatch;

    let _accessToken = this.props.accessToken;
    let _profile = this.props.profile;

    if (_accessToken && _profile) {
      // console.log('LAST VERSION', this.state.version, 'CURRENT VERSION', config.version);
      if (this.state.version !== config.version) {
        await dispatch({ ...initialStoreState, type: "set" });

        await this.setState({
          loading: false,
        });

        window.location.replace("/logout");
      } //if
    } //if

    await this.setState({
      loading: false,
    });
  }

  render() {
    //let props = this.props;

    return (
      <Router>
        <React.Suspense fallback={<Spinner fullScreen={true} />}>
          {this.state.loading ? (
            <Spinner fullScreen={true} />
          ) : (
            <Switch>
              <Route
                exact
                path="/login"
                name="Login Page"
                render={(props) => <Login {...props} i18n={this.state.i18n} API_HOST={baseUrl} />}
              />
              <Route
                exact
                path="/set-password"
                name="Set Password Page"
                render={(props) => (
                  <SetPassword {...props} i18n={this.state.i18n} API_HOST={baseUrl} />
                )}
              />
              <Route
                exact
                path="/reset/:token"
                name="Reset Page"
                render={(props) => <Reset {...props} i18n={this.state.i18n} API_HOST={baseUrl} />}
              />
              <Route
                exact
                path="/recover/:email?"
                name="Recover Page"
                render={(props) => <Recover {...props} i18n={this.state.i18n} API_HOST={baseUrl} />}
              />
              <Route
                exact
                path="/logout"
                name="Logout Page"
                render={(props) => <Logout {...props} i18n={this.state.i18n} API_HOST={baseUrl} />}
              />
              <Route
                exact
                path="/register"
                name="Register Page"
                render={(props) => (
                  <Register {...props} i18n={this.state.i18n} API_HOST={baseUrl} />
                )}
              />
              <Route
                exact
                path="/404"
                name="Page 404"
                render={(props) => <Page404 {...props} i18n={this.state.i18n} API_HOST={baseUrl} />}
              />
              <Route
                exact
                path="/500"
                name="Page 500"
                render={(props) => <Page500 {...props} i18n={this.state.i18n} API_HOST={baseUrl} />}
              />
              <Route
                path="/"
                name="Home"
                render={(props) => (
                  <TheLayout {...props} i18n={this.state.i18n} API_HOST={baseUrl} />
                )}
              />
            </Switch>
          )}
        </React.Suspense>
      </Router>
    );
  }
}

//export default App;

const mapStateToProps = function (state) {
  return {
    menus: state.menus,
    links: state.links,
    schemas: state.schemas,
    widgets: state.widgets,
    accessToken: state.accessToken,
    profile: state.profile,
    currentBreakpoint: state.currentBreakpoint,
    version: state.version,
  };
};

export default connect(mapStateToProps)(App);
